export const DEFAULT_PLACEHOLDER =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPk1Hf9DwACRAF+iwmAMQAAAABJRU5ErkJggg==';
